export const parts= [
    {pid: '1.2', label: 'Timing Belt', rate:21},        
    {pid: '1.2', label: 'Main Shaft', rate:15},
    {pid: '1.2', label: 'King Pin', rate:20},
    {pid: '2.1', label: 'Clutch Cable'},
    {pid: '2.1', label: 'Clutch Cable pin'},
    {pid: '2.2', label: 'Engine Mounting'},
    {pid: '2.3', label: 'Engine Rear pin'},
    {pid: '2.4', label: 'Layshaft Assy'},
    {pid: '2.5', label: 'Engine Nozzle'},
    {pid: '4.1', label: 'Air cooler'},
    {pid: '4.1', label: 'Air filter'},
    {pid: '7.1', label: 'Gear Lever bush'},
    {pid: '7.1', label: 'Gear king pin'},
    {pid: '7.2', label: 'Gear Bush'},
    {pid: '8.1.1', label: 'Brake Cable bush'},
    {pid: '8.1.1', label: 'Brake Cable assy'},
    {pid: '8.1.2', label: 'Brake pad'},
    {pid: '8.1.2', label: 'Brake pad bush'},
    {pid: '8.2.1', label: 'Grease'},
    {pid: '8.2.1', label: 'Hub Assy'},
    {pid: '8.2.1', label: 'Hub Pin'},
    {pid: '9.1.1', label: 'head ligh bulb'},
    {pid: '9.1.2', label: 'head light assy'},
    {pid: '9.1.2', label: 'head light assy bush'},
    {pid: '9.2.1', label: 'Rear fuse'},
    {pid: '9.2.1', label: 'Rear fuse conector'},
    {pid: '9.2.2', label: 'Rear ligh bulb'},
    {pid: '10.1', label: 'Air Gas'},
    {pid: '1.2', label: 'Glass Winder Assy'},
    {pid: '12.1', label: 'Glass Winder pin'},
    {pid: '12.2', label: 'Rear View Mirroy Assy'},
    {pid: '12.2', label: 'Mirror bush'},
    {pid: '12.2', label: 'Miror pin'},
    {pid: '13.1', label: 'Lock assy'},
    {pid: '13.1', label: 'Lock Cable'},
    {pid: '13.2', label: 'Door Lock Assy'},
]
   
